import { render, staticRenderFns } from "./ShowLastInvoice.vue?vue&type=template&id=18003e8e"
import script from "./ShowLastInvoice.vue?vue&type=script&lang=js"
export * from "./ShowLastInvoice.vue?vue&type=script&lang=js"
import style0 from "./ShowLastInvoice.vue?vue&type=style&index=0&id=18003e8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports